<template>
    <div>
        <br />
        <!-- loading spinner -->
        <div v-if="loading" id="devices-data-loading" style="text-align: center; margin-top: 10%;">
            <div class="lds-facebook"><div></div><div></div><div></div></div>
            <div>Loading devices...</div>
        </div>
        <div v-else>
            <h4 class="device-filter-heading">Huon Aquaculture (Tasmania)</h4>
            <div class="device-filter-container">
                <div v-for="device in devices" v-bind:key="device.id">
                    <div class="card-container">
                        <device-card :item="device" />
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    // import moment from 'moment'
    import DeviceCard from '../DeviceCard.vue';

    export default {
        name: "DevicesContent",
        components: { DeviceCard },
        data: function () {
            return {
                loading: true,
                devices: [],
                deviceTempAndFlow: [
                    {
                        name: "dummy",
                        temp: null,
                        belowZero: false,
                        flow: null,
                        device_operation_status: null
                    },
                    {
                        name: "dummy",
                        temp: null,
                        belowZero: false,
                        flow: null,
                        device_operation_status: null
                    },
                    {
                        name: "dummy",
                        temp: null,
                        belowZero: false,
                        flow: null,
                        device_operation_status: null
                    },
                    {
                        name: "Vitrafy-00005",
                        temp: null,
                        belowZero: false,
                        flow: null,
                        device_operation_status: null
                    },
                    {
                        name: "dummy",
                        temp: null,
                        belowZero: false,
                        flow: null,
                        device_operation_status: null
                    },
                    {
                        name: "dummy",
                        temp: null,
                        belowZero: false,
                        flow: null,
                        device_operation_status: null
                    },
                    {
                        name: "Vitrafy-00007",
                        temp: null,
                        belowZero: false,
                        flow: null,
                        device_operation_status: null
                    },
                    {
                        name: "dummy",
                        temp: null,
                        belowZero: false,
                        flow: null,
                        device_operation_status: null
                    }
                ],
            };
        },
        props: {},
        created: async function () {
            await setTimeout(() => { // Make it looks like the table is loading
                this.getDevices();
            }, 500)
        },
        mounted: function () {

        },
        methods: {
            async getDevices() {
                this.loading = true;

                try {
                    let url = "https://t0wxzdk096.execute-api.ap-southeast-2.amazonaws.com/beta/lifelink";
                    let headers = {
                        'x-api-key': 'NMKFcHIzMT7ToX0O9eRXW7yXA22zGM0B7ddc8Xpy'
                    };

                    const response = await this.$http.get(
                        url,
                        {headers: headers}
                    );
                    
                    /* TODO: remove this filter */
                    // Filter by only the 2 devices we're interested in
                    this.devices = response.data.Items.filter((device) => device.id == 'Vitrafy-00005' || device.id == 'Vitrafy-00007');

                    for (var i = 0; i < this.devices.length; i++) {
                        // details
                        this.$set(this.devices[i], 'details', "Cryopreservation Apparatus")

                        // online
                        var currentTime = new Date().getTime();
                        var diff = (currentTime - this.devices[i].deviceTimestamp) / 1000;
                        this.$set(this.devices[i], 'diff', diff)
                        var online = true;
                        var offline = false;

                        // if no response after 3min device is considered offline
                        if (diff > 180) {
                            online = false;
                            offline = true;
                        }
                        this.$set(this.devices[i], 'online', online)
                        this.$set(this.devices[i], 'offline', offline)
                        
                        // deviceCPU
                        this.devices[i].deviceCPU = Math.round(this.devices[i].deviceCPU * 10) / 10

                        // deviceMEM
                        var deviceMEM = (100 / this.devices[i].deviceTotalMem) * this.devices[i].deviceUsedMem
                        deviceMEM = Math.round(deviceMEM * 10) / 10
                        this.$set(this.devices[i], 'deviceMEM', deviceMEM)                     

                        // Add location to each device and Long/Lat coords
                        if(this.devices[i].id == "Vitrafy-00005")
                        {
                            this.$set(this.devices[i], 'location', 'Huon Aquaculture (Tasmania)');
                            this.$set(this.devices[i], 'coords', {lat: -42.77597315561563, lng: 147.05388827190774});
                        }
                        if(this.devices[i].id == "Vitrafy-00007")
                        {
                            this.$set(this.devices[i], 'location', 'Huon Aquaculture (Tasmania)');
                            this.$set(this.devices[i], 'coords', {lat: -42.77597315561563, lng: 147.05388827190774});
                        }

                        // convert timestamp
                        var convertedTimestamp = new Date(this.devices[i].deviceTimestamp);
                        this.$set(this.devices[i], 'convertedTimestamp', convertedTimestamp);

                        // find diff in seconds 
                        var lastCommunicationSeconds = Math.round(Date.now() / 1000) - Math.round(this.devices[i].deviceTimestamp / 1000)
                        if(lastCommunicationSeconds < 1) {lastCommunicationSeconds = 3;}
                        this.$set(this.devices[i], 'lastCommunicationSeconds', lastCommunicationSeconds);

                        // format diff in seconds
                        this.$set(this.devices[i], 'formattedLastCommunicationSeconds', this.timeCalculator(lastCommunicationSeconds).replace('secondago', 'second ago'));

                    }

                    // reorder devices by name (id)
                    this.devices.sort(function(a, b){
                        if(a.id < b.id) { return -1; }
                        if(a.id > b.id) { return 1; }
                        return 0;
                    })

                    // get machine temp data for specific devices (if online!);
                    for (i = 0; i < this.devices.length; i++) {
                        if (this.devices[i].id != 'dummy') this.getMachineTempData(this.devices[i].id);
                    }

                } catch (error) {
                    console.log(error);
                }

                console.log("devices from API: ", this.devices)
                this.loading = false;
            },
            async getMachineTempData(id) {
                console.log("Getting temp data for machine: ", id)
                let url = process.env.VUE_APP_MULE_PROXY_API_URI;

                let headers = {
                    'Content-Type': 'application/json;charset=utf-8',
                    'authorization': localStorage.idtoken
                };

                var data = {
                    "endpoint": "/api/devices/" + id + "/data?mode=stream"
                };

                data = JSON.stringify(data);
                
                try {
                    const response = await this.$http.post(
                        url,
                        data,
                        { headers: headers }
                    );

                    for (var i = 0; i < response.data.length; i++) {
                        if(response.data[i].length > 0 ) {
                            var element = response.data[i];
                            if (element[0].TagID == "analogs_lc_lrt_scaled") {                                
                                    var temp = element[0].TagValue.toFixed(1);
                                    if(id == 'Vitrafy-00005') {
                                        this.deviceTempAndFlow[3].temp = temp;
                                        this.deviceTempAndFlow[3].belowZero = (temp < 1)
                                    }
                                    if(id == 'Vitrafy-00007') {
                                        this.deviceTempAndFlow[6].temp = temp;
                                        this.deviceTempAndFlow[6].belowZero = (temp < 1)
                                    }
                                }
                            }

                            if (element[0].TagID == "pids_lc_flow_pid_pv") {
                                var deviceFlowActual = element[0].TagValue.toFixed(1);

                                if(id == 'Vitrafy-00005') this.deviceTempAndFlow[3].flow = deviceFlowActual;
                                if(id == 'Vitrafy-00007') this.deviceTempAndFlow[6].flow = deviceFlowActual;
                            }
                            var me = this;
                            if (element[0].TagID == "operation_global_operationdescription") {
                                var deviceStatus = element[0].stringvalue;

                                for (var itemsCounter = 0; itemsCounter < me.devices.length; itemsCounter++){
                                    if(id == me.devices[itemsCounter].id) me.devices[itemsCounter].device_operation_status = deviceStatus;
                                }
                            }
                        }
                } catch (error) {
                    console.log(error);
                }
            },
            timeCalculator: function(seconds) {
                let y = Math.floor(seconds / 31536000);
                let mo = Math.floor((seconds % 31536000) / 2628000);
                let d = Math.floor(((seconds % 31536000) % 2628000) / 86400);
                let h = Math.floor((seconds % (3600 * 24)) / 3600);
                let m = Math.floor((seconds % 3600) / 60);
                let s = Math.floor(seconds % 60);

                let yDisplay = y > 0 ? y + (y === 1 ? " year, " : " years, ") : "";
                let moDisplay = mo > 0 ? mo + (mo === 1 ? " month, " : " months, ") : "";
                let dDisplay = d > 0 ? d + (d === 1 ? " day, " : " days, ") : "";
                let hDisplay = h > 0 ? h + (h === 1 ? " hour, " : " hours, ") : "";
                let mDisplay = m > 0 ? m + (m === 1 ? " minute " : " minutes, ") : "";
                let sDisplay = s > 0 ? s + (s === 1 ? " second" : " seconds ") : "";
                return yDisplay + moDisplay + dDisplay + hDisplay + mDisplay + sDisplay + "ago";
            },
        }
    };
</script>

<style>
.device-filter-heading { margin-bottom: 15px; }

.device-filter-container {
    float: left;
    width: 100%;
    margin-bottom: 15px;
}

.card-container {
    float: left;
    margin-right: 20px;
    margin-bottom: 20px;
    box-shadow: 0 3px 1px -2px rgb(0 0 0 / 20%), 0 2px 2px 0 rgb(0 0 0 / 14%), 0 1px 5px 0 rgb(0 0 0 / 12%);
    max-width: 364px !important;
}

@media (max-width: 767px) {
    .card-container {
        position: relative !important;
        margin-right: 0px !important;
        width: 100% !important;
        max-width: 100% !important;
    }
}
</style>
